import { Card, CardContent } from "@/components/ui/card";
import EmailUser from "@/domain/entities/emails/EmailUser";
import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { Button } from "../ui/button";

interface UserInfoCardProps {
    user: EmailUser;
    avatarUrl?: string | null;
}

const UserInfoCard = ({ user, avatarUrl }: UserInfoCardProps) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (user.email) {
            await navigator.clipboard.writeText(user.email);
            setCopied(true);
            setTimeout(() => setCopied(false), 1200);
        }
    };

    return (
        <Card className="p-1" size="sm" variant="default">
            <CardContent className="m-0 px-3 py-2">
                <div className="flex items-center justify-center gap-3">
                    {avatarUrl && (
                        <div className="h-12 w-12 overflow-hidden rounded-full">
                            <img
                                alt={`${user.name}'s avatar`}
                                className="h-full w-full object-cover"
                                src={avatarUrl}
                            />
                        </div>
                    )}
                    <div className="flex flex-col text-text-subtitle">
                        <span className="text-text-main-title font-medium">
                            {user.name}
                        </span>
                        <span className="flex items-center gap-2 text-sm">
                            {user.email}
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopy();
                                }}
                                size="smallCircle"
                                variant="ghost"
                            >
                                {copied ? (
                                    <Check className="h-4 w-4 text-green-600" />
                                ) : (
                                    <Copy className="h-4 w-4" />
                                )}
                            </Button>
                        </span>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default UserInfoCard;
